import Checkout from "../../components/features/checkout/Checkout";

const CheckoutPage = () => {
  return <Checkout />;
};

export default CheckoutPage;
